import { render, staticRenderFns } from "./customer-map.vue?vue&type=template&id=19db4b1e&"
import script from "./customer-map.vue?vue&type=script&lang=js&"
export * from "./customer-map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports